'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { AuthApi, AuthQueryKey, UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { PolicyCard } from '@/components/molecule/PolicyCard';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useAuthStore } from '@/stores/AuthStore';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { SectionTitle } from '../SectionTitle';
import { PolicyDialogContent } from './PolicyDialogContent';
interface PolicyContentProps {
  institutionId: number;
}
export const PolicyContent = t0 => {
  const $ = _c(28);
  const {
    institutionId
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const pageSize = isDesktopViewport ? 3 : 4;
  const isLogin = useAuthStore(_temp);
  let T0;
  let handlePolicyClick;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== institutionId || $[1] !== isLogin || $[2] !== pageSize) {
    const queryKey = isLogin ? AuthQueryKey["get:/wello/v2/auth/home/institution/policy"]() : UnauthQueryKey["get:/wello/v2/allows/home/institution/policy"]();
    handlePolicyClick = _temp2;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <SectionTitle className={cn("mb-32", "mobile-tablet:mb-12")}>정책</SectionTitle>;
      t3 = cn("grid grid-cols-3 gap-x-18 gap-y-16", "mobile-tablet:grid-cols-1");
      $[10] = t3;
      $[11] = t4;
    } else {
      t3 = $[10];
      t4 = $[11];
    }
    T0 = InfiniteListWithMoreButton;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <InfiniteListMoreButton className={cn("mt-40", "mobile-tablet:mt-20")} />;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    t2 = [...queryKey, institutionId, pageSize];
    t5 = t6 => {
      const {
        pageParam
      } = t6;
      return (isLogin ? AuthApi["get:/wello/v2/auth/home/institution/policy"] : UnauthApi["get:/wello/v2/allows/home/institution/policy"])({
        query: {
          institutionId,
          page: pageParam,
          size: pageSize
        }
      }).then(_temp3);
    };
    $[0] = institutionId;
    $[1] = isLogin;
    $[2] = pageSize;
    $[3] = T0;
    $[4] = handlePolicyClick;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[3];
    handlePolicyClick = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[13] !== handlePolicyClick) {
    t6 = item => <PolicyCard key={item.id} border={true} benefit={item.supportBenefit} bookmarkCount={item.wishlistCount} commentCount={item.commentCount} id={item.id} idIdx={item.metaPolicyIdIdx} imageUrl={item.agencyLogo} isBookmarked={item.wishlistYN} name={item.policyName} onClick={() => handlePolicyClick(item.metaPolicyIdIdx)} />;
    $[13] = handlePolicyClick;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== T0 || $[16] !== pageSize || $[17] !== t1 || $[18] !== t2 || $[19] !== t5 || $[20] !== t6) {
    t7 = <T0 moreButtonComponent={t1} queryKey={t2} queryFn={t5} pageSize={pageSize} renderItem={t6} getItemKey={_temp4} />;
    $[15] = T0;
    $[16] = pageSize;
    $[17] = t1;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t3 || $[23] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[22] = t3;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t4 || $[26] !== t8) {
    t9 = <div>{t4}{t8}</div>;
    $[25] = t4;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(policyIdx) {
  openResponsiveDialog({
    component: PolicyDialogContent,
    props: {
      policyIdIdx: policyIdx
    },
    modalHeader: {
      title: "\uC815\uCC45"
    },
    className: {
      modal: "max-w-[800px]"
    },
    drawerType: "bottom"
  });
}
function _temp3(data) {
  return data.data?.context?.contents ?? [];
}
function _temp4(item_0) {
  return item_0.id;
}